import styled, { css } from 'styled-components';
import { Icon as IconComponent } from '../../icons';
import { Color, Spacing } from '../../theme';
const borderRadius = '0.375rem';
export const Card = styled.div `
  background-color: ${Color.WHITE};
  box-shadow: ${(props) => props.theme.shadows.base};
  margin-bottom: ${(props) => (props.small ? Spacing.XS : Spacing.M)};
  border-radius: ${borderRadius};
  display: flex;
  height: ${(props) => (props.fullHeight ? '100%' : 'auto')};
  flex-direction: column;

  ${(props) => props.outline &&
    css `
      box-shadow: none;
      border: 1px solid ${Color.GRAY_300};
    `}
`;
export const Content = styled.div `
  flex-grow: 1;
  padding: ${(props) => (props.noContentPadding ? 0 : props.small ? Spacing.S : Spacing.M)};
`;
export const TitleContainer = styled.div `
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
`;
export const Icon = styled(IconComponent) `
  height: 2.25rem;
  width: 2.25rem;
  margin-right: ${Spacing.XS};
`;
export const Header = styled.div `
  border-bottom: 1px solid ${Color.GRAY_200};
  padding: ${(props) => (props.small ? Spacing.S : Spacing.M)};
`;
export const Footer = styled.div `
  border-top: 1px solid ${Color.GRAY_200};
  padding: ${(props) => (props.small ? Spacing.S : Spacing.M)};
`;
export const Image = styled.img `
  border-top-right-radius: ${borderRadius};
  border-top-left-radius: ${borderRadius};
  vertical-align: middle;
  max-width: 100%;
  height: auto;
`;
//# sourceMappingURL=card.styles.js.map